<div class="container">
    <div class="row product-row">
        <div class="col-lg col-12 product-col">
            <div class="product-box">
                <div class="product-details">
                    <div class="gallery">
                        <div class="gallery-container">
                            <app-product-gallery-new [productLayout]="layout"
                                [images]="product.images"></app-product-gallery-new>
                        </div>
                    </div>

                    <div class="details">
                        <!-- Shipping Restriction Warning - Compact Version -->
                        @if (!canShipToUserCountry) {
                        <div class="shipping-restriction-compact" role="alert">
                            <mat-icon>info_outline</mat-icon>
                            <span>{{ getShippingRestrictionMessage() }}</span>
                        </div>
                        }

                        <h1 class="product-name">{{ translateHelper.localize(product.name) }}</h1>
                        @if (translateHelper.localize(product.promotionalCaption)) {
                        <h3>{{ translateHelper.localize(product.promotionalCaption) }}</h3>
                        }

                        @if (product.code) {
                        <p class="item-code">
                            <small>{{"item_code"|translate}}: <b class="bolder">{{product.code}}</b></small>
                        </p>
                        }

                        @if (product.brandData) {
                        <div class="product-brand">
                            <img [src]="product.brandData.url">
                        </div>
                        }

                        @if (!product.optionVariant || (product.optionVariant?.type == 'G' &&
                        !product.optionVariant?.isParent)) {
                        @if (product.quantity?.amount > 0 && product.type == 'product' && product.sample?.status) {
                        <div class="actions-item mb-2">
                            <button eventCollector eventName="request_sample" category="product_page" itemType="product"
                                [companyId]="product.companyData?._id" [productId]="product._id" type="button"
                                class="primary-button mb-2 request_sample" [ngClass]="{'btn-loading': addingToCart}"
                                style="min-width: max-content;" appClick (click)="addToCart(true)">
                                <div class="icon">
                                    <mat-icon svgIcon="add_to_cart_custom"></mat-icon>
                                </div>
                                <div class="label">{{"request_sample"|translate}}</div>
                            </button>
                            @if (product.sample.price) {
                            <small class="d-none d-md-block mb-2" [ngStyle]="{'color': getColor(true)}">
                                {{"sample_price"|translate}}: {{product.sample.price}}
                            </small>
                            }
                        </div>
                        }

                        @if (!product?.isOnlyQuotation && !product.isOfferable && !product.hidePrice) {
                        <div class="prices">
                            @if (product.taxedPrice < product.baseTaxedPrice) { 
                            <div class="old-price">{{ product.baseTaxedPrice || product.price | currencyConvert : product.companyData.currencyMeta.code }}</div>
                            <span class="new-price">
                                {{ product.taxedPrice | currencyConvert : product.companyData.currencyMeta.code }}
                            </span>
                            }
                            @if (product.taxedPrice >= product.baseTaxedPrice) {
                            <span class="current-price">
                                {{ product.taxedPrice || product.price | currencyConvert : product.companyData.currencyMeta.code }}
                            </span>
                            }
                        </div>
                        }

                    @if (product?.vat == 'I' || product?.vat == 'E') {
                    <div class="vat">{{"inclusive"|translate}}</div>
                    }

                    @if (!addToCartHidden && !isQuotable && product?.quantity?.min > 1) {
                    <div style="color: #eb3545; font-size: 13px;">{{"minimum_quantity"|translate}}:
                        {{product?.quantity?.min}}
                    </div>
                    }

                    <!-- Quantity discount -->
                    @if (product.quantityDiscount?.length > 0) {
                    <div class="quantity-discount">
                        <p>{{"quantity_discounts"|translate}}</p>
                        <div class="">
                            <table class="table table-sm">
                                <thead>
                                    <tr>
                                        <th>{{"quantity"|translate}}</th>
                                        <th>{{"discount"|translate}}</th>
                                        <th>{{"price"|translate}}</th>
                                    </tr>
                                </thead>
                                <tbody class="">
                                    <tr *ngFor="let discount of product.quantityDiscount">
                                        <td>{{ discount.quantity }}+</td>
                                        <td>
                                            @if (discount.type=='F') {
                                            {{ discount.discountValue | currencyConvert : product.companyData.currencyMeta.code }}
                                            }
                                            @if (discount.type=='P') {
                                            {{ discount.discountValue}}%
                                            }
                                        </td>
                                        <td>{{ discount.taxedPrice | currencyConvert : product.companyData.currencyMeta.code }}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    }

                    <!-- .product__var -->
                    @if (product.variants) {
                    <div class="product__tags tags mt-3">
                        <div class="tags__list">
                            @if (product.variants) {
                            <div class="form-groupp product__optionn">
                                <div class="form-group" *ngFor="let variant of product.variants | keyvalue">

                                    @if (product.variantSelectionField != 'radio') {
                                    <div>
                                        <label class="product__option-label control-label">
                                            {{translateHelper.localize(variant?.value?.name)}}
                                        </label>

                                        <select [formControl]="variantSelection" class="form-control"
                                            (change)="navigateTo($event.target.value)">
                                            <option [attr.selected]
                                                [value]="((this.product.sector?.seo?.slug) ?'/sector/'+ this.product.sector?.seo?.slug+'/':'/')+ productVariant.value.type+'/'+productVariant.value.seo.slug"
                                                appClick
                                                *ngFor=" let productVariant of variant?.value?.products | keyvalue">
                                                {{translateHelper.localize(productVariant?.value?.variant[variant?.key]?.value)}}
                                            </option>
                                        </select>
                                    </div>
                                    }

                                    @if (product.variantSelectionField == 'radio') {
                                    <div class="product__optionn">
                                        <label
                                            class="product__option-label control-label">{{translateHelper.localize(variant?.value?.name)}}</label>
                                        <div class="input-radio-label">
                                            <div class="input-radio-label__list">
                                                <label
                                                    *ngFor="let productVariant of variant?.value?.products | keyvalue">
                                                    <input
                                                        (change)="navigateTo(((this.product.sector?.seo?.slug) ?'/sector/'+ this.product.sector?.seo?.slug+'/':'/')+ productVariant.value.type+'/'+productVariant.value.seo.slug)"
                                                        [formControl]="variantSelection" type="radio"
                                                        [value]="'/'+productVariant.value.type+'/'+productVariant.value.seo.slug">
                                                    <span>{{translateHelper.localize(productVariant?.value?.variant[variant?.key]?.value)}}</span>
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                    }
                                </div>
                            </div>
                            }
                        </div>
                    </div>
                    }

                    }

                    @if (product.quantity?.amount > 0 && product.optionVariant && !_.isEmpty(product.optionVariant))
                    {
                    <app-product-variants-options [baseForm]="form" [optionsObject]="product.optionVariant"
                        [product]="product">
                    </app-product-variants-options>
                    }

                    @if (!product.optionVariant || (product.optionVariant?.type == 'G' &&
                    !product.optionVariant?.isParent)) {
                    <!-- Quotation Price suggestion -->
                    @if ((isQuotable && product?.suggestPriceRange?.min && product?.suggestPriceRange?.max)) {
                    <div fxLayout="column" fxLayoutAlign="start start" [formGroup]="form">
                        <label>
                            {{"suggest_price"|translate}}
                            {{product?.suggestPriceRange?.min|currencyConvert : product.companyData.currencyMeta.code}}
                            {{"and"|translate}}
                            {{product?.suggestPriceRange?.max|currencyConvert : product.companyData.currencyMeta.code}}
                        </label>
                        <div fxLayout="row" fxLayoutAlign="start center">
                            <input formControlName="suggestPrice" [min]="product?.suggestPriceRange?.min"
                                [max]="product?.suggestPriceRange?.max" [value]="form.value.suggestPrice"
                                class="price_suggestion">
                            @if (form.controls['suggestPrice'].invalid) {
                            <div style="color: red; font-size: 14px">{{"price_must_be_in_range"|translate}}.</div>
                            }
                        </div>
                    </div>
                    }

                    @if (product.quantity?.amount > 0 && canShipToUserCountry) {
                    <div class="product-option">
                        @if (!product?.isOfferable) {
                        <!-- <label class="product__option-label d-none d-md-block">{{"quantity"|translate}}</label> -->
                        @if (isQuotable && (product?.minQuotationAmount > 1)) {
                        <small class="d-none d-md-block mb-2 min-quote"
                            [ngStyle]="{'color': getColor(form?.value?.amount >= product?.minQuotationAmount)}">
                            {{"min_quotation_quantity"|translate}}: {{product?.minQuotationAmount}}
                        </small>
                        }
                        }

                        <div class="hidden product-actions" [ngClass]="{'mobile-fab': isMobile}">
                            @if (!addToCartHidden && !isBookingProduct) {
                            <app-input-number-new appClick layout="input-4" (addToCart)="addToCart()"
                                aria-label="Quantity" class="product__quantity-availability amount"
                                [min]="product.quantity?.min" [max]="product.quantity?.max"
                                [step]="product.quantity?.step" [formControl]="amount">
                            </app-input-number-new>
                            }

                            @if (addToCartHidden && isQuotable && !isBookingProduct) {
                            <app-input-number-new appClick layout="input-5" aria-label="Quantity"
                                class="product__quantity-availability amount quote-qty" [min]="product.quantity?.min"
                                [max]="product.quantity?.max" [step]="product.quantity?.step" [formControl]="amount">
                            </app-input-number-new>
                            }

                            @if (isQuotable && !isBookingProduct) {
                            <button type="button" eventCollector eventName="add_to_quotation" category="product_page"
                                itemType="product" [companyId]="product.companyData?._id" [productId]="product._id"
                                [disabled]="form.controls['suggestPrice'].invalid || amount.value < product?.minQuotationAmount"
                                (click)="addQuotation()" class="primary-button"
                                [ngClass]="{'btn-loading': addingToCart}" appClick>
                                <div class="icon">
                                    <mat-icon svgIcon="quotation-tag"></mat-icon>
                                </div>
                                <div class="label">{{ "add_quotation" | translate }}</div>
                            </button>
                            }

                            <!-- @if (!product?.isOfferable) {
                                @if (product.subtype?.comparable) {
                                    <div class="actions-item">
                                        <button type="button" appClick eventCollector eventName="add_to_quotation"
                                            category="product_page" itemType="product" [companyId]="product.companyData?._id"
                                            [productId]="product._id" (click)="addToCompare()" class="primary-button"
                                            [ngClass]="{'btn-loading': addingToCompare}">
                                            <div class="icon">
                                                <mat-icon>equalizer</mat-icon>
                                            </div>
                                            <div class="label">{{"add_compare"|translate}}</div>
                                        </button>
                                    </div>
                                }
                            } -->

                            <!-- @if (product?.isOfferable && canOffer) {
                            <div class="actions-item">
                                <input [formControl]="offeredPrice" [placeholder]="'offer_price'|translate"
                                    class="form-control" type="number" min="0">
                            </div>
                            <div class="actions-item">
                                <button type="button" class="btn btn-primary" [ngClass]="{'btn-loading': addingToCart}"
                                    appClick (click)="makeOffer()">{{"make_offer"|translate}}</button>
                            </div>
                            } -->

                            <!-- @if (product?.variants?.length && product?.variantsDisplayMode == 'MODAL') {
                            <div class="actions-item">
                                <button class="btn btn-secondary" (click)="showVariantsList();">{{'product_variants'|translate}}</button>
                            </div>
                            } -->
                        </div>

                        @if (product?.isOfferable && !canOffer) {
                        <small>{{"you_made_offer"|translate}}</small>
                        }

                        @if (availableShippings?.length > 0) {
                        <div fxLayout="column" fxLayoutAlign="start start" class="vendor-info my-2">
                            <h4>Shipping:</h4>
                            <div *ngFor="let shipping of availableShippings" fxLayout="row"
                                fxLayoutAlign="start center">
                                <span class="mx-2">{{translateHelper.localize(shipping.name)}}</span>
                                <span class="mx-2"> - {{shipping.calculatedRate.totalTaxed|currencyConvert : product.companyData.currencyMeta.code}}</span>
                            </div>
                        </div>
                        }
                    </div>
                    }
                    <!-- <p class="availability">
                                <mat-icon>check_circle</mat-icon>
                                {{"availability"|translate}}:
                                @if (!product.noStores) {
                                    @if (product.quantity?.amount > 0) {
                                        <b class="text-success">{{"in_stock"|translate}}</b>
                                    } @else {
                                        <b class="text-danger">{{"out_of_stock"|translate}}</b>
                                     }
                                }
                                @if (product.noStores) {
                                    <b class="text-danger">{{product.noStores|translate}}</b>
                                }
                        </p> -->
                    }
                    

                    @if (product.quantity?.amount > 0 && product.options && optionsLength && optionsLength < 3 && canShipToUserCountry) {
                        <app-product-options [class]="'limit-options'" [baseForm]="form"
                        [optionsObject]="product.options" [product]="product">
                        </app-product-options>
                        }

                        <div class="mb-3 mt-2">
                            <app-social-share-buttons [layout]="'col'"></app-social-share-buttons>
                        </div>

                </div>
            </div>

            <!-- @if (!product.optionVariant || (product.optionVariant?.type == 'G'&& !product.optionVariant?.isParent)) { -->
            @if (product.quantity?.amount > 0 && product.options && optionsLength && optionsLength >= 3 && canShipToUserCountry) {
            <div class="options-box">
                <app-product-options [baseForm]="form" [optionsObject]="product.options" [product]="product">
                </app-product-options>
            </div>
            }
            <!-- } -->

            <!-- ADD THE BOOKING SECTION HERE -->
            @if (isBookingProduct && canShipToUserCountry) {
    <div class="booking-section card-radius-06 bg-card-new mt-4">
        <!-- Collapsible Header -->
        <div class="booking-header" 
             (click)="toggleBookingSection()"
             [title]="getBookingToggleTooltip()">
            <div class="header-content">
                <div class="booking-title">
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                        <rect x="3" y="4" width="18" height="18" rx="2" ry="2"/>
                        <line x1="16" y1="2" x2="16" y2="6"/>
                        <line x1="8" y1="2" x2="8" y2="6"/>
                        <line x1="3" y1="10" x2="21" y2="10"/>
                    </svg>
                    <h3>{{ 'BOOKING' | translate }}</h3>
                    <!-- <span class="booking-badge" *ngIf="bookingPrice > 0">
                        {{ getBookingPriceBadge() }}
                    </span> -->
                </div>
                <div class="toggle-icon" 
                     [class.expanded]="isBookingSectionOpen"
                     [attr.aria-label]="getBookingToggleTooltip()">
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                        <path d="M6 9l6 6 6-6"/>
                    </svg>
                </div>
            </div>
            
        </div>
        
        <!-- Collapsible Content -->
        <div class="booking-content" [class.expanded]="isBookingSectionOpen">
            <div class="booking-content-inner">
                <!-- Per Day Booking -->
                @if (product?.booking?.bookingType === 'perDay') {
                    <app-per-day-booking 
                        [product]="product"
                        (bookingCreated)="onBookingCreated($event)"
                        (addedToCart)="onBookingAddedToCart($event)"
                        (quotationRequested)="onQuotationRequested($event)"
                        (priceCalculated)="onBookingPriceCalculated($event)"
                        (selectedDatesChanged)="onSelectedDatesChanged($event)">
                    </app-per-day-booking>
                } @else if (product?.booking?.bookingType === "period") {
                    <app-period-booking
                        [product]="product"
                        (bookingCreated)="onBookingCreated($event)"
                        (addedToCart)="onBookingAddedToCart($event)"
                        (quotationRequested)="onQuotationRequested($event)"
                        (priceCalculated)="onBookingPriceCalculated($event)"
                        (selectedDatesChanged)="onSelectedDatesChanged($event)">
                    </app-period-booking>
                } @else if (product?.booking?.bookingType === 'timeSlots') {
                    <app-time-slot-booking
                        [product]="product"
                        (bookingCreated)="onBookingCreated($event)"
                        (addedToCart)="onBookingAddedToCart($event)"
                        (quotationRequested)="onQuotationRequested($event)"
                        (priceCalculated)="onBookingPriceCalculated($event)"
                        (selectedSlotsChanged)="onSelectedSlotsChanged($event)">
                    </app-time-slot-booking>
                }
            </div>
        </div>
    </div>
}

<div>
    @if (canShipToUserCountry) {
    <div class="quote-actions" [class.!hidden]="isMobile">
                    @if (!addToCartHidden && !isBookingProduct) {
                    <app-input-number-new appClick layout="input-4" (addToCart)="addToCart()" aria-label="Quantity"
                        class="product__quantity-availability" [min]="product.quantity?.min"
                        [max]="product.quantity?.max" [step]="product.quantity?.step"
                        [formControl]="amount"></app-input-number-new>

                        <!-- Buy Now button: visible when Add to Cart is visible -->
                            <button type="button"
                                    class="primary-button ms-2"
                                    [disabled]="addingToCart || amount.value <= 0"
                                    (click)="buyNow()">
                                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                    <path d="M3 3h18v4H3z"></path>
                                    <path d="M6 14l3 3 9-9"></path>
                                </svg>
                                <div class="label">{{ "buyNow" | translate }}</div>
                            </button>
                    }

                    @if (addToCartHidden && isQuotable && !isBookingProduct) {
                    <app-input-number-new appClick layout="input-5" aria-label="Quantity"
                        class="product__quantity-availability amount quote-qty" [min]="product.quantity?.min"
                        [max]="product.quantity?.max" [step]="product.quantity?.step"
                        [formControl]="amount"></app-input-number-new>
                    }

                    @if (isQuotable && !isBookingProduct) {
                    <button type="button" eventCollector eventName="add_to_quotation" category="product_page"
                        itemType="product" [companyId]="product.companyData?._id" [productId]="product._id"
                        [disabled]="form.controls['suggestPrice'].invalid || amount.value < product?.minQuotationAmount"
                        (click)="addQuotation()" class="primary-button" [ngClass]="{'btn-loading': addingToCart}"
                        appClick>
                        <div class="icon">
                            <mat-icon svgIcon="quotation-tag"></mat-icon>
                        </div>
                        <div class="label">{{"add_quotation"|translate}}</div>
                    </button>
                    }
                </div>
            }
            </div>
        </div>

        <!-- desc and features -->
        <div class="description-box card-radius-06">
            <mat-tab-group [mat-stretch-tabs]="false">

                <mat-tab>

                    <ng-template mat-tab-label>
                        <div class="tab-label">
                            <div class="icon">
                                <mat-icon svgIcon="report"></mat-icon>
                            </div>
                            <span class="pt-1">{{'description'|translate}}</span>
                        </div>
                    </ng-template>
                    <div class="description-info">

                        <div class="typography">
                            <div [innerHTML]="translateHelper.localize(product?.description)"></div>
                        </div>

                    </div>
                </mat-tab>

                @if (features) {
                <mat-tab>
                    <ng-template mat-tab-label>
                        <div class="tab-label">
                            <div class="icon">
                                <mat-icon svgIcon="star-square"></mat-icon>
                            </div>
                            <span class="pt-1">{{'features'|translate}}</span>
                        </div>
                    </ng-template>

                    <div class="features-info">
                        @for (feature of features | keyvalue; track feature.key) {
                        <div class="speceeee__row">
                            <div class="speceeee__name">{{ feature.key }}</div>
                            @if (feature.value?.type !=='color') {
                            <div class="speceeee__value">{{ feature.value.name }}</div>
                            } @else {
                            <div [ngClass]="['input-check-color--' + (feature.value.name|colorType)]"
                                [style.color]="feature.value.name" class="speceeee__value">
                                <span class="input-check-color__box"></span>
                            </div>
                            }
                        </div>
                        }
                    </div>
                </mat-tab>
                }

            </mat-tab-group>
        </div>
        <!-- <app-product-tabs-new [product]="product"></app-product-tabs-new> -->
    </div>
    <div class="col-lg-auto col-12 vendor-col">
        <div class="bg-card-new card-radius-06">
            @if (product.companyData) {
            <div class="vendor-box">
                <div class="vendor-info">
                    @if (product?.companyData?.design) {
                    <div class="logo">
                        <a [routerLink]="['/vendor', product.companyData?.seo?.slug]">
                            <img
                                [src]="product.companyData?.design?.logo?.thumb?.url || product.companyData?.design.logo.url">
                        </a>
                    </div>
                    }
                    <div class="w-full">
                        <a class="vendor-name" [routerLink]="['/vendor', product.companyData?.seo?.slug]">
                            {{translateHelper.localize(product.companyData?.name)}}
                        </a>
                        <div class="desc w-full mt-3">
                            <div>
                                <ng-scrollbar pointerEventsMethod="scrollbar" appearance="standard" class="c-scroll">
                                    <div [innerHTML]="translateHelper.localize(product?.companyData?.description)">
                                    </div>
                                </ng-scrollbar>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="controls">
                    <div class="company-controls">
                        @if (whatsapp) {
                        <a eventCollector eventName="whatsapp" category="product_page" itemType="product"
                            [companyId]="product.companyData?._id" [productId]="product._id"
                            href="https://api.whatsapp.com/send?phone={{whatsapp?.number}}&text={{whatsapp?.text}}"
                            class="btn green btn-secondary" target="_blank">
                            <div class="icon"><mat-icon inline="true" svgIcon="chat-elipses"></mat-icon></div>
                        </a>
                        }

                        <button eventCollector [companyId]="product.companyData?._id" [productId]="product._id"
                            eventName="vendor_chat" (click)="openChat();" category="product_page" itemType="product"
                            class="primary-button">
                            <div class="icon">
                                <mat-icon svgIcon="chat-info"></mat-icon>
                            </div>
                            <div class="label">{{"chat_with_vendor"|translate}}</div>
                        </button>
                    </div>
                </div>
            </div>
            }
        </div>

        <!-- Qunatity Calculater -->
        @if (product.view == 'tc' && product.measurements?.dimensions?.length &&
        product.measurements?.dimensions?.width) {
        <div class="bg-card-new card-radius-06 mt-4 quantity-calculator">
            <div class="title-box">
                <div>{{"calculate_tiles_text"|translate}}</div>
            </div>
            <div class="p-4 flex flex-col">
                <div class="flex flex-col gap-1">
                    @for (areaForm of formsList; track areaForm; let i = $index) {
                    <div class="flex flex-col" [formGroup]="areaForm">
                        <div class="area">Area {{i+1}}</div>
                        <div class="flex flex-row gap-4">
                            <div class="form-group">
                                <label class="control-label">{{"width_metter"|translate}}</label>
                                <input type="text" class="form-control form-control-rounded" formControlName="width">
                            </div>

                            <div class="form-group">
                                <label class="control-label">{{"length_metter"|translate}}</label>
                                <input type="text" class="form-control form-control-rounded" formControlName="length">
                            </div>

                            @if (formsList.length > 1) {
                            <button type="button" class="btn btn-secondary remove-btn" (click)="removeArea()">X</button>
                            }
                        </div>
                    </div>
                    }
                </div>
                <div class="flex flex-row gap-4 mt-3">
                    <button type="button" class="btn btn-primary btn-calculate"
                        (click)="getAreaPrice()">{{"calculate"|translate}}</button>
                    <button type="button" class="btn btn-primary btn-add" style="width: 100%" (click)="addArea()"><mat-icon fontIcon="add">add</mat-icon>{{"add_area"|translate}}</button>
                </div>
                <div style="border: 0; padding: 5px; margin-top: 8px">
                    <div class='flex-auto'>
                        <div>
                            <table class="calc-table" style="table-layout: fixed;">
                                <thead>
                                    <tr>
                                        <th style="padding-right: 15px;">{{"quantity_needed"|translate}}</th>
                                        <th>{{"price"|translate}}</th>
                                    </tr>
                                </thead>
                                <tbody class="">
                                    <tr>
                                        <td>{{ tCount }} </td>
                                        <td>{{ tPrice|currencyConvert : product.companyData.currencyMeta.code }}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div class="flex flex-row">
                        <div class="form-check">
                            <span class="form-check-input input-check">
                                <span class="input-check__body">
                                    <input class="input-check__input" type="checkbox" name="extra" id="extra"
                                        value="additional-coverage" checked="" (click)="getAreaPrice()" />
                                    <span class="input-check__box rounded-full"></span>
                                    <app-icon class="input-check__icon" name="selectChecked" size="9x7"></app-icon>
                                </span>
                            </span>
                            <label class="form-check-label" for="extra">{{"add_10%_in_case_of_damage"|translate}}</label>
                        </div>
                    </div>
                </div>
                <div>
                    <small class="note">{{"calulcate_tiles_note"|translate}}</small>
                </div>
            </div>
        </div>
        }


        <!-- Blocks Calculator -->
        @if (product.view == 'bc' && product.measurements?.dimensions?.length &&
        product.measurements?.dimensions?.height) {
        <div class="mt-4">
            <app-blocks-calculator [productId]="product._id" [companyId]="product.companyData?._id"
                [height]="product.measurements?.dimensions?.height" [width]="product.measurements?.dimensions?.width"
                [type]="product.measurements?.dimensions?.type"
                [taxedPrice]="this.product.taxedPrice"
                [currencyCode]="product.companyData.currencyMeta.code"></app-blocks-calculator>
        </div>
        }

    </div>
</div>

<ng-template #modal>
    <!--   <div class="modal-header">
          <h2 class="headline m-0" fxFlex="auto">{{"Request for Quote"|translate}}</h2>
        <button class="btn-close" aria-label="Close" (click)="bsModalRef.hide()">
        </button>
    </div> -->

    <div class="scroll">
        <div class="min-h-[450px] flex flex-row relative">
            <button class="btn-close absolute right-4 top-4" aria-label="Close" (click)="bsModalRef.hide()">
            </button>
            <div class="flex flex-col w-64 gap-2 p-3 product-info bg-[#fdfdfd]">
                <div>
                    <img class="w-full h-48 object-contain rounded-md"
                        [src]="product.images?.[0]?.url" />
                </div>
                <div class="text-base font-semibold">
                    {{ translateHelper.localize(product.name) }}
                </div>
                <div>
                    {{"qty"|translate}}: {{amount.value}}
                </div>
                <div>
                    <span class="text-sm">{{"by"|translate}}: </span>
                    <span class="text-sm font-bold">{{translateHelper.localize(product.companyData?.name)}}</span>
                </div>

                @if (selectedOptions.length) {
                    @for (option of selectedOptions; track option.value) {
                    <div>
                        <span class="text-sm">{{translateHelper.localize(option.label)}}: </span>
                        @if (option.type == ProductOptionType.ColorGroup) {
                            <div class="color" [style.background-color]="option.value"></div>
                        } @else if(option.type == ProductOptionType.SelectBox || option.type == ProductOptionType.RadioGroup) {
                            <span class="text-sm font-bold">{{translateHelper.localize(option.value?.name)}}</span>
                        } @else if(option.type == ProductOptionType.Checkbox) {
                            <span class="text-sm font-bold">
                                @if(option.value) { {{"yes"|translate}} } @else { {{"no"|translate}} }
                            </span>
                        } @else if(option.type == ProductOptionType.Text) {
                            <span class="text-sm font-bold">{{option.value}}</span>
                        } @else if(option.type == ProductOptionType.File) {
                            <span class="text-sm font-bold">
                                @if(option.value) { {{"file_attached"|translate}} } @else { {{"no_file_attached"|translate}} }
                            </span>
                        } @else if(option.type == ProductOptionType.Date) {
                            <span class="text-sm font-bold">{{option.value}}</span>
                        } @else {
                            <span class="text-sm font-bold">{{option.value}}</span>
                        }
                    </div>
                    }
                }
            </div>
            <div class="flex flex-auto flex-col p-5 justify-center items-center gap-6">
                <div class="w-full text-2xl font-semibold">
                    {{"a_quote_request_will_be_sent_to_vendor"|translate}}
                </div>

                <div class="w-full">
                    <div class="text-lg font-medium my-2">{{"request_details"|translate}}</div>
                    <textarea matinput [formControl]="quoteDescription" [placeholder]="translateHelper.localize('have_a_question?_feel_free_to_ask')"
                        class="w-full p-3" rows="5"></textarea>
                </div>

                <div>
                    <button class="primary-button" [ngClass]="{'btn-loading': addingToCart}" type="button" (click)="requestQuotation()">
                        {{"send_request" | translate}}
                    </button>
                </div>


            </div>

        </div>
    </div>

    <!-- @if (product.companyData) {
        <div class="quotation-vendor-info">
            @if (product?.companyData?.design) {
            <img class="logo"
                [src]="product.companyData?.design?.logo?.thumb?.url || product.companyData?.design.logo.url">
            }
            <div class="text-base  text-default-blue">
                A quote for the following items will be sent to {{translateHelper.localize(product.companyData?.name)}},
                to proceed click on 'Send Request'
            </div>

        </div>
        <mat-divider class="mb-4"></mat-divider>
        } -->
    <!--  <div class="flex flex-row gap-2 flex-wrap">
            <div class="flex flex-row   w-full">
                <div class="text-base shrink-0 basis-10/12">
                    Product
                </div>
                <div class="text-base shrink-0 basis-2/12">
                    Qty
                </div>
            </div>
            <mat-divider class="mb-2 w-full"></mat-divider>

            <div class="flex flex-row items-center w-full">
                <div class="font-bold text-base shrink-0 basis-10/12 flex flex-row gap-2 ">
                    <img class="w-16 rounded-md" [src]="product.images?.[0]?.url" />
                    {{ translateHelper.localize(product.name) }}
                </div>
                <div class="font-bold text-base shrink-0 basis-2/12">
                    {{amount.value}}
                </div>
            </div>
        </div> -->

    <!-- <div class="product product--layout--quickview">
            <div class="product__info">
                @if (selectedOptions.length) {
                <div class="selected-options">
                    @for (option of selectedOptions; track option.value) {
                    <div class="option">
                        <span>{{option.label}}:</span>
                        @if (option.type == 'CL') {
                        <div class="color" [style.background-color]="option.value"></div>
                        } @else {
                        <span>{{option.value}}</span>
                        }
                    </div>
                    }
                </div>
                }
            </div>
        </div>
    </div>
 -->
    <!--   <div class="modal-footer">
        <button class="primary-button" [ngClass]="{'btn-loading': addingToCart}" type="button"
            (click)="requestQuotation()">
            {{"Send Request" | translate}}
        </button>
    </div> -->
</ng-template>
</div>
<!-- <app-product-tabs-new [product]="product"></app-product-tabs-new> -->
